import { render, staticRenderFns } from "./EventDetailHeader.vue?vue&type=template&id=13b3925c&scoped=true&"
import script from "./EventDetailHeader.vue?vue&type=script&lang=js&"
export * from "./EventDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailHeader.vue?vue&type=style&index=0&id=13b3925c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b3925c",
  null
  
)

export default component.exports